// extracted by mini-css-extract-plugin
export default {"leagueHeader":"LeagueHeader_leagueHeader__NYpu2","headerElapsedTime":"LeagueHeader_headerElapsedTime__uw3fK","finishedLiveFixture":"LeagueHeader_finishedLiveFixture__R2kAJ"};